import script from "./ThresholdSlider.vue?vue&type=script&setup=true&lang=ts"
export * from "./ThresholdSlider.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__